module.exports = __webpack_public_path__ + "img/20200704_220135.4ae86528.jpg";